import { html, LitElement } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { OverlayPositionX, SelectOption } from '../../gzSelect/types';
import type { ButtonFontSize, ButtonType } from '../types';
import { ButtonFontSizes, ButtonTypes, SplitButtonEvents } from '../types';
import { ButtonColor, ButtonFill, FontSize } from '../../gzIconButton/types';
import { classMap } from 'lit/directives/class-map.js';
import { GzSelectWebComponent } from '../../gzSelect';

@customElement('gz-split-button')
export class GzSplitButtonWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  options: Array<SelectOption>;

  @property({ type: String, attribute: true, reflect: true })
  overlayPositionX: OverlayPositionX = OverlayPositionX.RIGHT;

  @property({ type: String, attribute: true, reflect: true })
  buttonType: ButtonType = ButtonTypes.FULL;

  @property({ type: String, attribute: true, reflect: true })
  buttonFontSize: ButtonFontSize = ButtonFontSizes.MEDIUM;

  @property({ type: String, reflect: true })
  buttonColor: ButtonColor = ButtonColor.PRIMARY;

  @property({ type: String, attribute: true, reflect: true })
  btnText: '';

  @query('gz-select')
  selectElement!: GzSelectWebComponent;

  static get styles() {
    return styles;
  }

  render() {
    const classes = {
      ['btn-type--' + this.buttonType]: this.buttonType,
    };

    return html`
      <gz-select .options=${this.options} overlayPositionX="${this.overlayPositionX}">
        <div class="wrap-split-button">
          <div class="split-button-container">
            <gz-button
              @click="${this.dispatchMainButtonClickEvent}"
              class="split-button"
              type="${this.buttonType}"
              color="${this.buttonColor}"
              buttonFontSize="${this.buttonFontSize}"
              >${this.btnText}</gz-button
            >
            <div class="separator"></div>
            <gz-icon-button
              class="split-button ${classMap(classes)}"
              buttonColor="${this.getButtonIconColor()}"
              buttonFill="${this.getButtonIconFill()}"
              fontSize="${FontSize.ICON_SIZE_20}"
              icon="ds-icon-textbox_decrease"
            ></gz-icon-button>
          </div>
        </div>
      </gz-select>
    `;
  }

  private getButtonIconColor(): string {
    switch (this.buttonType) {
      case ButtonTypes.FULL:
        return ButtonColor.WHITE;
      case ButtonTypes.OUTLINE:
        return this.buttonColor;
      case ButtonTypes.QUIET:
        return this.buttonColor;
    }
  }

  private getButtonIconFill(): ButtonFill | ButtonType {
    if (this.buttonType === ButtonTypes.FULL && this.buttonColor === ButtonColor.PRIMARY) {
      return ButtonFill.PRIMARY;
    }
    if (this.buttonType === ButtonTypes.OUTLINE && this.buttonColor === ButtonColor.PRIMARY) {
      return ButtonFill.OUTLINE;
    }

    return this.buttonType;
  }

  private dispatchMainButtonClickEvent(event: Event) {
    event.stopPropagation(); // stops the event from bubbling further and opening the select overlay
    if (this.selectElement.open) {
      this.selectElement.open = false;
    }
    this.dispatchEvent(
      new CustomEvent(SplitButtonEvents.MAIN_BUTTON_CLICK, {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-split-button': GzSplitButtonWebComponent;
  }
}
